<template>
  <div>
    <psychologistsComponent></psychologistsComponent>
  </div>
</template>

<script>
import psychologistsComponent from "../../../components/dashboard/adminDashboard/psychologistsComponent";
export default {
  name: "psychologists",
  components: { psychologistsComponent },
};
</script>

<style scoped></style>
